import { API_DATE_FORMAT, DateType } from 'module/types/common';
import { DateField } from 'module/types/filter-field/field/filterable-field';
import { DatePicker } from 'module/ui/components/atoms/date-picker';
import { humanise } from 'module/ui/components/atoms/humanised-date';
import { NoValue } from 'module/ui/components/atoms/no-value/empty-cell';
import moment from 'moment';
import { FC, RefObject } from 'react';
import { EditableProps } from './editable-props';

interface Props extends Partial<EditableProps<DateType>> {
  field?: DateField;
  innerRef?: RefObject<typeof DatePicker>;
  disabledDate?: any;
  value?: string;
  extraFooter?: any;
  allowClear?: boolean;
}

export const DateFieldValue: FC<React.PropsWithChildren<Props>> = ({
  field,
  id,
  editable,
  onChange,
  getPopupContainer,
  className,
  innerRef,
  disabledDate,
  value,
  extraFooter,
  allowClear = true,
}) => {
  return !editable ? (
    field?.value == null || !value ? (
      <NoValue />
    ) : field?.value ? (
      <>{humanise(moment(field?.value))}</>
    ) : (
      <>{humanise(moment(value))}</>
    )
  ) : (
    <DatePicker
      ref={innerRef as any}
      className={className}
      id={id}
      value={
        value
          ? moment(value)
          : field?.value != null
            ? moment(field?.value)
            : null
      }
      onChange={(latest) =>
        onChange?.(latest == null ? undefined : latest.format(API_DATE_FORMAT))
      }
      getPopupContainer={getPopupContainer}
      open
      disabledDate={disabledDate}
      renderExtraFooter={() => <>{extraFooter}</>}
      allowClear={allowClear}
    />
  );
};
